import React from 'react';

interface TabIconProps {
  active: boolean;
}

const BenefitsIcon: React.FC<TabIconProps> = ({ active }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.84533 14.8308C8.56417 15.4746 7.67313 15.4746 7.392 14.8308L6.66062 13.1556C6.00976 11.665 4.83824 10.4783 3.37692 9.82964L1.36382 8.93606C0.72378 8.65197 0.72378 7.72087 1.36382 7.43677L3.31404 6.57109C4.81294 5.90574 6.00547 4.67515 6.64522 3.13357L7.38608 1.34841C7.66099 0.685946 8.57633 0.685944 8.85125 1.34841L9.59208 3.13359C10.2318 4.67515 11.4243 5.90574 12.9233 6.57109L14.8735 7.43677C15.5135 7.72087 15.5135 8.65197 14.8735 8.93606L12.8604 9.82964C11.3991 10.4783 10.2276 11.665 9.57667 13.1556L8.84533 14.8308ZM3.78297 8.18642C5.68783 9.03197 7.23668 10.4218 8.11865 12.3341C9.00067 10.4218 10.5495 9.03197 12.4543 8.18642C10.5267 7.33078 8.973 5.8732 8.11866 3.92687C7.26432 5.87321 5.71056 7.33078 3.78297 8.18642ZM16.1678 18.9094L16.3735 18.438C16.7402 17.5975 17.4006 16.9282 18.2246 16.5621L18.8583 16.2806C19.201 16.1283 19.201 15.6302 18.8583 15.478L18.2601 15.2121C17.4148 14.8366 16.7426 14.1426 16.3822 13.2736L16.171 12.7641C16.0238 12.4091 15.5329 12.4091 15.3857 12.7641L15.1745 13.2736C14.8142 14.1426 14.1419 14.8366 13.2967 15.2121L12.6984 15.478C12.3558 15.6302 12.3558 16.1283 12.6984 16.2806L13.3321 16.5621C14.1562 16.9282 14.8165 17.5975 15.1832 18.438L15.3889 18.9094C15.5394 19.2545 16.0173 19.2545 16.1678 18.9094ZM15.3121 15.8736L15.7808 15.4081L16.2398 15.8736L15.7808 16.326L15.3121 15.8736Z"
      fill={active ? '#4E3178' : '#738290'}
    />
  </svg>
);

export default BenefitsIcon;
